import IPromotionRepository from 'domain/interfaces/repositories/IPromotionRepository'

export const readGetPromotionQuery = (repository: IPromotionRepository, promotionId: string) => {
  return repository.getPromotion(promotionId)
}
